import { Outlet } from "react-router-dom";
import NavBarContainer from "../../infrastructure/react/containers/NavBarContainer";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Footer from "../../infrastructure/react/components/Footer";
import {SideBarContainer} from "../../infrastructure/react/containers/SideBarContainer";
import { useEffect } from "react";
const ClientLayout = () => {
  const navigate = useNavigate();
  let userId = useSelector(state=>state.user._id);
  useEffect(()=>{
    if(!userId){
      navigate("/")
    }
  },[userId])
  return (
    <div className="parent-main-global-container">
      <SideBarContainer />
      <div className="parent-main-content">
        {window.location.pathname !== "/chats" && <NavBarContainer />}
        <Outlet />
        {/* <Footer /> */}
      </div>
    </div>
  );


};

export default ClientLayout;        